/* globals cpac */

if (typeof cpac !== 'undefined') {
  cpac.childcare = {
    addChild: function (lastRow) {
        cpac.table.duplicateLine(lastRow, true, 'after');
    },
    delChild: function (lastRow) {
        if (lastRow) {
            if (lastRow.previousSibling) {
                // remove last child's name
                lastRow.parentNode.removeChild(lastRow);
            } else {
                // empty last child's name
                var inputs = lastRow.getElementsByTagName('input');
                if (inputs) {
                    for (var i=0; i<inputs.length; i++) {
                        inputs[i].value = '';
                    }
                }
            }
        }
    }
  }
}